import './styles.scss';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

//components
import NormalTable from 'Components/Common/Table';

//redux
import { useDispatch } from "react-redux";
import { fetchCompanyUsers } from "../../../../../Redux/Slices/companyManagementSlice";
import Pagination from 'Components/Pagination';


function NoOfUsersCompanyManagement() { 
  const {id} = useParams();
  const dispatch = useDispatch();
  const [companyUser, setCompanyUsers] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const [sortOptions, setSortOptions] = useState({ sort_by: true, order_by: "createdAt" });


    const headerDetails = [
        {
          label: "S No",
          sortKey: false,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "company_name"})
          },
          
        },
        {
          label: "Users Name",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "firstname"})
          },
        },
        {
          label: "Mobile Number",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "mobile"})
          },
        },
        {
          label: "Email ID",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "email"})
          },
        },
        {
          label: "Last Logged",
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "last_login"})
          },
        },
        {
          label: 'Logged in Mintues',
          sortKey: true,
          singleClickFunc:() => {
            setSortOptions({sort_by: !sortOptions.sort_by, order_by: "active_time"})
          },
        }
      ]

      const handlePageChange = (page) => {
        setCurrentPage(page);
      }; 

     useEffect(()=>{
      dispatch(
        fetchCompanyUsers({
          data:{
            id,
            sort_by:sortOptions.sort_by?"ASC":"DESC",
            order_by: sortOptions.order_by, 
            page:currentPage,
            limit:10,
          },
          callBack:getDataCB
        })
      )
     },[sortOptions,currentPage]) 

     const getDataCB = (value) => {
      // console.log(value)
      setCompanyUsers(value.data.rows)
      setTotalPage(value.pageMeta.totalPages || 1)
     }
    return (
      <div className="NoOfUsersContainer">
        <div className="NoOfUsersTableContainer">
          <h2>No.of Users</h2>
          {companyUser.length>0?
          <>
          <NormalTable headerDetails={headerDetails}>
            {companyUser.map((user, index) => (
              <tr key={index} style={{ position: "relative" }}>
                <td>{(currentPage - 1) * 10 + (index + 1)}</td>
                <td>{user?.firstname || "-"}</td>
                <td>{user?.mobile || "-"}</td>
                <td>{user?.email || "-"}</td>
                <td>
                  {user?.last_login ? new Date(user?.last_login).toLocaleDateString("en-GB") :
                    "-"}
                </td>
                <td>{user?.active_time || "-"}</td>
              </tr>
            ))}
          </NormalTable>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          />
          </>:<p style={{textAlign:'center', fontFamily:'poppins', fontSize:"4vh", color: 'gray'}}>No Data Found</p>}
        </div>
      </div>
    );
}

export default NoOfUsersCompanyManagement;
